import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Experience from './pages/Experience';
import Education from './pages/Education';
import Contact from './pages/Contact';
import MirArmTherapy from './pages/MirArmTherapy';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/education" element={<Education />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/mirarmtherapy" element={<MirArmTherapy />} />
      </Routes>
      <CookieConsent />
    </Router>
  );
}

export default App;
